import instance from '../config/axios';

export async function removeProductFromCart(token: string, id: string) {
  try {
    const result = await instance({
      url: '/api/v1/cart/remove',
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: { product_id: id },
      validateStatus: (status) => {
        return status < 500;
      },
    });

    return { status: result.status, data: result.data };
  } catch (error) {
    console.log('Error removing product from cart:', error);
    return null;
  }
}
